<app-bread-crump [title]="('home.quranDecorations' | translate)" [description]="('quranDecorations.desc' | translate)"
  [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label: ('home.quranDecorations' | translate) }
  ]">
</app-bread-crump>

<section class="container d-flex flex-column my-5" style="max-width: 1280px">

  @if (loading()) {
  <div class="text-center my-5">
    <span>{{ 'COMMON.loading' | translate }}</span>
  </div>
  } @else {
  <div class="global-cards-row" style="margin-block: 40px;">
    @for (dec of decorations; track dec.id) {
    <div class="global-cards-row__container">
      <div class="global-card">
        <img loading="lazy" class="community_img" [src]="dec.imageUrl ? (dec.imageUrl.startsWith('http') ? dec.imageUrl : (environment.baseUrl + '/Files/' + dec.imageUrl)) : '/media/images/custom/defualt-img.jpg'" [alt]="dec.nameAR" onerror="this.src='/media/images/custom/defualt-img.jpg'" />
        <div class="texts">
          <h3>{{ translateService.currentLang === 'en' ? dec.nameEN : dec.nameAR }}</h3>
          <p class="description">
            {{ translateService.currentLang === 'en' ? dec.descEN : dec.descAR }}
          </p>
        </div>
        <div class="buttons justify-content-start">
          <button [routerLink]="['/quran-decorations-quran', dec.id]" class="btn-primary without-min" translate="READ_MORE"></button>
        </div>
      </div>
    </div>
    }
  </div>

  @if (decorations.length === 0) {
  <div class="text-center my-5">
    <p>{{ 'noItemsFound' | translate }}</p>
  </div>
  }

  @if (pagination.totalPages > 1) {
  <div class="mt-4">
    <app-browse-paginator [pagination]="pagination" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
  </div>
  }
  }
</section>
